import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'home-accounting',
    templateUrl: './home-accounting.component.html',
    styleUrls: ['./home-accounting.component.scss'],
    providers: [MessageService]
})
export class HomeAccountingComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
    }
}
